<div class="link-component">
    <app-layout-control>
        <app-control-label top [control]="control" [caption]="caption()" />
        <dx-tag-box #dx [items]="dataSource()" [valueExpr]="valueExpr()" [displayExpr]="displayExpr()" [value]="computedValue()"
            (onValueChanged)="onValueChanged($event)" (onBlur)="onTouched()" [isValid]="isValid" [maxDisplayedTags]="4" [minSearchLength]="0" [searchEnabled]="true"
            [searchExpr]="displayExpr()" [searchTimeout]="200" [showDataBeforeSearch]="false" [showMultiTagOnly]="false" [showSelectionControls]="true"
            placeholder="None" />
        <app-control-supporting-text bottom [control]="control" [controlName]="caption()" [helpText]="helpText()" [isValid]="isValid" />
    </app-layout-control>
</div>
